import { AfterViewInit, Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'ag-print-layout',
  templateUrl: './print-layout.component.html',
  styleUrls: ['./print-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PrintLayoutComponent implements AfterViewInit {
  constructor() {}

  ngAfterViewInit(): void {
    // Ensures that the html and body are not hidden or have inner overflow; needed for printing and page-breaks.
    document.getElementsByTagName('html')[0].style.overflow = 'visible';
    document.getElementsByTagName('body')[0].style.overflow = 'visible';
  }
}
